import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Bell } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL_MS = 60_000;

const NotificationBell = ({ className = '', user }) => {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${BACKEND_URL}/api/notifications/me?unread_only=true&limit=1`,
          { headers: { Authorization: `Bearer ${token}` } });
        if (!cancelled) setUnread(res.data.unread_count || 0);
      } catch (_) {}
    };
    fetchCount();
    const t = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, [user]);

  if (!user) return null;

  return (
    <button
      data-testid="notif-bell"
      onClick={() => navigate('/notifications')}
      className={`relative p-2 text-white/80 hover:text-white transition-colors ${className}`}
      aria-label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
    >
      <Bell aria-hidden="true" size={20} weight={unread > 0 ? 'fill' : 'regular'} className={unread > 0 ? 'text-[#facc15]' : ''} />
      {unread > 0 && (
        <span
          data-testid="notif-bell-count"
          aria-hidden="true"
          className="absolute top-0.5 right-0.5 min-w-[16px] h-[16px] px-1 bg-[#facc15] text-black text-[9px] font-extrabold rounded-full flex items-center justify-center"
        >
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
